
import { Component, Vue, Prop, PropSync, Watch } from "vue-property-decorator";

import { AROs, Documents, Firearms, User } from "@/hooks";
import { AROViewModel, NewAroLinkModel } from "models";
import { axiosInstance } from "@/plugins/axios";
import { watch } from "vue";

@Component
export default class LinkAroToAdminModal extends Vue {
  @Prop() adminId!: string | null;
  @Prop() adminIds!: string[];
  @PropSync("open") openModal!: boolean;
  valid = false;

  users: AROViewModel[] = [];
  selectedUserId: number | null = null;
  creatingNewUser = false;

  newUser: NewAroLinkModel = {
    idNumber: "",
    PSIRARegistrationNumber: "",
    isSecurityGuard: false,
    employeeNumber: "",
    address: "",
    userId: "",
  };

  get filteredUsers() {
    console.log(
      "User ids ",
      this.adminIds,
      this.users.map((e) => e.userID)
    );
    return this.users.filter((user) => !this.adminIds.includes(user.userID));
  }
  rules = {
    id: (value: string): boolean | string =>
      (value ? value.length == 13 && /^(?!^0*$)/.test(value) : true) ||
      "Requires a valid 13 digit ID number",
    required: (value: string): boolean | string =>
      !!value || "This field is Required.",
  };
  /*  mounted() {
    this.fetchUsers();
  } */

  @Watch("openModal")
  async openStateChanged() {
    if (this.openModal == true) {
      await this.fetchUsers();
    }
  }

  toggleCreateUser() {
    this.creatingNewUser = !this.creatingNewUser;
    this.selectedUserId = null;
  }
  async fetchUsers() {
    try {
      const response = AROs.getAros();
      this.users = (await response).arOs;
      console.log("users", this.users);
    } catch (error) {
      console.error("Failed to fetch users", error);
    }
  }

  async submit() {
    if (!this.adminId) return;

    if (this.creatingNewUser) {
      await this.createAndLinkUser();
    } else if (this.selectedUserId) {
      await this.linkExistingUser();
    }
  }

  async linkExistingUser() {
    try {
      if (this.selectedUserId != null && this.adminId != null) {
        await User.linkAroToAdmin(this.adminId, this.selectedUserId);
        this.$emit("linked");
        this.closeModal();
      }
    } catch (error) {
      console.error("Failed to link user", error);
    }
  }

  async createAndLinkUser() {
    try {
      if (!this.adminId) {
        return;
      }
      this.newUser.userId = this.adminId;
      await User.createAndLinkAro(this.newUser);
      this.$emit("linked");
      this.closeModal();
    } catch (error) {
      console.error("Failed to create and link user", error);
    }
  }

  closeModal() {
    // close modal
    this.openModal = false;
    this.users = [];
    this.selectedUserId = null;
    this.creatingNewUser = false;
  }
}
